/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ClaimContactsResponse,
  Contact,
  ContactOrganization,
  ContactOrganizationsResponse,
  ContactPropertiesResponse,
  ContactPropertyLink,
  CreateContactRequest,
  LinkContactOrganizationRequest,
  LinkContactPropertyRequest,
  ListContactsResponse,
  Problem,
  UpdateContactRequest,
} from '../models/index';
import {
    ClaimContactsResponseFromJSON,
    ClaimContactsResponseToJSON,
    ContactFromJSON,
    ContactToJSON,
    ContactOrganizationFromJSON,
    ContactOrganizationToJSON,
    ContactOrganizationsResponseFromJSON,
    ContactOrganizationsResponseToJSON,
    ContactPropertiesResponseFromJSON,
    ContactPropertiesResponseToJSON,
    ContactPropertyLinkFromJSON,
    ContactPropertyLinkToJSON,
    CreateContactRequestFromJSON,
    CreateContactRequestToJSON,
    LinkContactOrganizationRequestFromJSON,
    LinkContactOrganizationRequestToJSON,
    LinkContactPropertyRequestFromJSON,
    LinkContactPropertyRequestToJSON,
    ListContactsResponseFromJSON,
    ListContactsResponseToJSON,
    ProblemFromJSON,
    ProblemToJSON,
    UpdateContactRequestFromJSON,
    UpdateContactRequestToJSON,
} from '../models/index';

export interface CreateContactOperationRequest {
    createContactRequest: CreateContactRequest;
}

export interface DeleteContactRequest {
    id: number;
}

export interface GetContactRequest {
    id: number;
}

export interface GetContactClaimsRequest {
    id: number;
    limit?: number;
    offset?: number;
}

export interface GetContactOrganizationsRequest {
    id: number;
    limit?: number;
    offset?: number;
}

export interface GetContactPropertiesRequest {
    id: number;
    limit?: number;
    offset?: number;
}

export interface LinkContactOrganizationOperationRequest {
    id: number;
    linkContactOrganizationRequest: LinkContactOrganizationRequest;
}

export interface LinkContactPropertyOperationRequest {
    id: number;
    linkContactPropertyRequest: LinkContactPropertyRequest;
}

export interface ListContactsRequest {
    contactType?: string;
    organizationId?: number;
    search?: string;
    limit?: number;
    offset?: number;
}

export interface UnlinkContactOrganizationRequest {
    id: number;
    organizationId: number;
}

export interface UnlinkContactPropertyRequest {
    id: number;
    propertyId: number;
    addressType?: string;
}

export interface UpdateContactOperationRequest {
    id: number;
    updateContactRequest: UpdateContactRequest;
}

/**
 * ContactsApi - interface
 * 
 * @export
 * @interface ContactsApiInterface
 */
export interface ContactsApiInterface {
    /**
     * 
     * @summary Create a contact
     * @param {CreateContactRequest} createContactRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContactsApiInterface
     */
    createContactRaw(requestParameters: CreateContactOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Contact>>;

    /**
     * Create a contact
     */
    createContact(requestParameters: CreateContactOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Contact>;

    /**
     * 
     * @summary Delete a contact
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContactsApiInterface
     */
    deleteContactRaw(requestParameters: DeleteContactRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Delete a contact
     */
    deleteContact(requestParameters: DeleteContactRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @summary Get contact by ID
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContactsApiInterface
     */
    getContactRaw(requestParameters: GetContactRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Contact>>;

    /**
     * Get contact by ID
     */
    getContact(requestParameters: GetContactRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Contact>;

    /**
     * 
     * @summary Get all claims linked to a contact
     * @param {number} id 
     * @param {number} [limit] 
     * @param {number} [offset] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContactsApiInterface
     */
    getContactClaimsRaw(requestParameters: GetContactClaimsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ClaimContactsResponse>>;

    /**
     * Get all claims linked to a contact
     */
    getContactClaims(requestParameters: GetContactClaimsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ClaimContactsResponse>;

    /**
     * 
     * @summary List organizations linked to a contact
     * @param {number} id 
     * @param {number} [limit] 
     * @param {number} [offset] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContactsApiInterface
     */
    getContactOrganizationsRaw(requestParameters: GetContactOrganizationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ContactOrganizationsResponse>>;

    /**
     * List organizations linked to a contact
     */
    getContactOrganizations(requestParameters: GetContactOrganizationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ContactOrganizationsResponse>;

    /**
     * 
     * @summary List properties linked to a contact
     * @param {number} id 
     * @param {number} [limit] 
     * @param {number} [offset] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContactsApiInterface
     */
    getContactPropertiesRaw(requestParameters: GetContactPropertiesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ContactPropertiesResponse>>;

    /**
     * List properties linked to a contact
     */
    getContactProperties(requestParameters: GetContactPropertiesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ContactPropertiesResponse>;

    /**
     * 
     * @summary Link an organization to a contact
     * @param {number} id 
     * @param {LinkContactOrganizationRequest} linkContactOrganizationRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContactsApiInterface
     */
    linkContactOrganizationRaw(requestParameters: LinkContactOrganizationOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ContactOrganization>>;

    /**
     * Link an organization to a contact
     */
    linkContactOrganization(requestParameters: LinkContactOrganizationOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ContactOrganization>;

    /**
     * 
     * @summary Link a property to a contact
     * @param {number} id 
     * @param {LinkContactPropertyRequest} linkContactPropertyRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContactsApiInterface
     */
    linkContactPropertyRaw(requestParameters: LinkContactPropertyOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ContactPropertyLink>>;

    /**
     * Link a property to a contact
     */
    linkContactProperty(requestParameters: LinkContactPropertyOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ContactPropertyLink>;

    /**
     * 
     * @summary List contacts
     * @param {string} [contactType] Filter by contact type (e.g. insurance_adjuster, contractor_personnel, homeowner)
     * @param {number} [organizationId] Filter by organization
     * @param {string} [search] Search by name or email
     * @param {number} [limit] 
     * @param {number} [offset] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContactsApiInterface
     */
    listContactsRaw(requestParameters: ListContactsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListContactsResponse>>;

    /**
     * List contacts
     */
    listContacts(requestParameters: ListContactsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListContactsResponse>;

    /**
     * 
     * @summary Unlink an organization from a contact
     * @param {number} id 
     * @param {number} organizationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContactsApiInterface
     */
    unlinkContactOrganizationRaw(requestParameters: UnlinkContactOrganizationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Unlink an organization from a contact
     */
    unlinkContactOrganization(requestParameters: UnlinkContactOrganizationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @summary Unlink a property from a contact
     * @param {number} id 
     * @param {number} propertyId 
     * @param {string} [addressType] When provided, only the link with this address type is removed. When omitted, all links between the contact and property are removed.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContactsApiInterface
     */
    unlinkContactPropertyRaw(requestParameters: UnlinkContactPropertyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Unlink a property from a contact
     */
    unlinkContactProperty(requestParameters: UnlinkContactPropertyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @summary Update a contact
     * @param {number} id 
     * @param {UpdateContactRequest} updateContactRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContactsApiInterface
     */
    updateContactRaw(requestParameters: UpdateContactOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Contact>>;

    /**
     * Update a contact
     */
    updateContact(requestParameters: UpdateContactOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Contact>;

}

/**
 * 
 */
export class ContactsApi extends runtime.BaseAPI implements ContactsApiInterface {

    /**
     * Create a contact
     */
    async createContactRaw(requestParameters: CreateContactOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Contact>> {
        if (requestParameters['createContactRequest'] == null) {
            throw new runtime.RequiredError(
                'createContactRequest',
                'Required parameter "createContactRequest" was null or undefined when calling createContact().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/contacts`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateContactRequestToJSON(requestParameters['createContactRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ContactFromJSON(jsonValue));
    }

    /**
     * Create a contact
     */
    async createContact(requestParameters: CreateContactOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Contact> {
        const response = await this.createContactRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Delete a contact
     */
    async deleteContactRaw(requestParameters: DeleteContactRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling deleteContact().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/contacts/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete a contact
     */
    async deleteContact(requestParameters: DeleteContactRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteContactRaw(requestParameters, initOverrides);
    }

    /**
     * Get contact by ID
     */
    async getContactRaw(requestParameters: GetContactRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Contact>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getContact().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/contacts/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ContactFromJSON(jsonValue));
    }

    /**
     * Get contact by ID
     */
    async getContact(requestParameters: GetContactRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Contact> {
        const response = await this.getContactRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get all claims linked to a contact
     */
    async getContactClaimsRaw(requestParameters: GetContactClaimsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ClaimContactsResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getContactClaims().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['offset'] != null) {
            queryParameters['offset'] = requestParameters['offset'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/contacts/{id}/claims`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ClaimContactsResponseFromJSON(jsonValue));
    }

    /**
     * Get all claims linked to a contact
     */
    async getContactClaims(requestParameters: GetContactClaimsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ClaimContactsResponse> {
        const response = await this.getContactClaimsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * List organizations linked to a contact
     */
    async getContactOrganizationsRaw(requestParameters: GetContactOrganizationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ContactOrganizationsResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getContactOrganizations().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['offset'] != null) {
            queryParameters['offset'] = requestParameters['offset'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/contacts/{id}/organizations`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ContactOrganizationsResponseFromJSON(jsonValue));
    }

    /**
     * List organizations linked to a contact
     */
    async getContactOrganizations(requestParameters: GetContactOrganizationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ContactOrganizationsResponse> {
        const response = await this.getContactOrganizationsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * List properties linked to a contact
     */
    async getContactPropertiesRaw(requestParameters: GetContactPropertiesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ContactPropertiesResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getContactProperties().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['offset'] != null) {
            queryParameters['offset'] = requestParameters['offset'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/contacts/{id}/properties`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ContactPropertiesResponseFromJSON(jsonValue));
    }

    /**
     * List properties linked to a contact
     */
    async getContactProperties(requestParameters: GetContactPropertiesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ContactPropertiesResponse> {
        const response = await this.getContactPropertiesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Link an organization to a contact
     */
    async linkContactOrganizationRaw(requestParameters: LinkContactOrganizationOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ContactOrganization>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling linkContactOrganization().'
            );
        }

        if (requestParameters['linkContactOrganizationRequest'] == null) {
            throw new runtime.RequiredError(
                'linkContactOrganizationRequest',
                'Required parameter "linkContactOrganizationRequest" was null or undefined when calling linkContactOrganization().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/contacts/{id}/organizations`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: LinkContactOrganizationRequestToJSON(requestParameters['linkContactOrganizationRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ContactOrganizationFromJSON(jsonValue));
    }

    /**
     * Link an organization to a contact
     */
    async linkContactOrganization(requestParameters: LinkContactOrganizationOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ContactOrganization> {
        const response = await this.linkContactOrganizationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Link a property to a contact
     */
    async linkContactPropertyRaw(requestParameters: LinkContactPropertyOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ContactPropertyLink>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling linkContactProperty().'
            );
        }

        if (requestParameters['linkContactPropertyRequest'] == null) {
            throw new runtime.RequiredError(
                'linkContactPropertyRequest',
                'Required parameter "linkContactPropertyRequest" was null or undefined when calling linkContactProperty().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/contacts/{id}/properties`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: LinkContactPropertyRequestToJSON(requestParameters['linkContactPropertyRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ContactPropertyLinkFromJSON(jsonValue));
    }

    /**
     * Link a property to a contact
     */
    async linkContactProperty(requestParameters: LinkContactPropertyOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ContactPropertyLink> {
        const response = await this.linkContactPropertyRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * List contacts
     */
    async listContactsRaw(requestParameters: ListContactsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListContactsResponse>> {
        const queryParameters: any = {};

        if (requestParameters['contactType'] != null) {
            queryParameters['contactType'] = requestParameters['contactType'];
        }

        if (requestParameters['organizationId'] != null) {
            queryParameters['organizationId'] = requestParameters['organizationId'];
        }

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['offset'] != null) {
            queryParameters['offset'] = requestParameters['offset'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/contacts`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ListContactsResponseFromJSON(jsonValue));
    }

    /**
     * List contacts
     */
    async listContacts(requestParameters: ListContactsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListContactsResponse> {
        const response = await this.listContactsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Unlink an organization from a contact
     */
    async unlinkContactOrganizationRaw(requestParameters: UnlinkContactOrganizationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling unlinkContactOrganization().'
            );
        }

        if (requestParameters['organizationId'] == null) {
            throw new runtime.RequiredError(
                'organizationId',
                'Required parameter "organizationId" was null or undefined when calling unlinkContactOrganization().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/contacts/{id}/organizations/{organizationId}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"organizationId"}}`, encodeURIComponent(String(requestParameters['organizationId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Unlink an organization from a contact
     */
    async unlinkContactOrganization(requestParameters: UnlinkContactOrganizationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.unlinkContactOrganizationRaw(requestParameters, initOverrides);
    }

    /**
     * Unlink a property from a contact
     */
    async unlinkContactPropertyRaw(requestParameters: UnlinkContactPropertyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling unlinkContactProperty().'
            );
        }

        if (requestParameters['propertyId'] == null) {
            throw new runtime.RequiredError(
                'propertyId',
                'Required parameter "propertyId" was null or undefined when calling unlinkContactProperty().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['addressType'] != null) {
            queryParameters['addressType'] = requestParameters['addressType'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/contacts/{id}/properties/{propertyId}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"propertyId"}}`, encodeURIComponent(String(requestParameters['propertyId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Unlink a property from a contact
     */
    async unlinkContactProperty(requestParameters: UnlinkContactPropertyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.unlinkContactPropertyRaw(requestParameters, initOverrides);
    }

    /**
     * Update a contact
     */
    async updateContactRaw(requestParameters: UpdateContactOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Contact>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling updateContact().'
            );
        }

        if (requestParameters['updateContactRequest'] == null) {
            throw new runtime.RequiredError(
                'updateContactRequest',
                'Required parameter "updateContactRequest" was null or undefined when calling updateContact().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/contacts/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateContactRequestToJSON(requestParameters['updateContactRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ContactFromJSON(jsonValue));
    }

    /**
     * Update a contact
     */
    async updateContact(requestParameters: UpdateContactOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Contact> {
        const response = await this.updateContactRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
